/* ==========================================================================
   Predictive search: fetches Shopify's native suggest.json (section-rendered)
   ========================================================================== */
(function () {
  'use strict';

  var form = document.querySelector('[data-predictive-search-form]');
  if (!form) return;

  var input = form.querySelector('[data-predictive-search-input]');
  var resultsEl = document.querySelector('[data-predictive-search-results]');
  var currentController = null;

  function search(term) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    var url =
      '/search/suggest?q=' +
      encodeURIComponent(term) +
      '&section_id=predictive-search&resources[type]=product,collection,page,query&resources[limit]=6';

    return fetch(url, { signal: currentController.signal })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        resultsEl.innerHTML = html;
        resultsEl.hidden = false;
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') console.error(err);
      });
  }

  input.addEventListener(
    'input',
    theme.debounce(function () {
      var term = input.value.trim();
      if (term.length < 2) {
        resultsEl.hidden = true;
        resultsEl.innerHTML = '';
        return;
      }
      search(term);
    }, 250)
  );

  form.addEventListener('submit', function (event) {
    if (input.value.trim().length === 0) event.preventDefault();
  });
})();
